import { getEnvironmentConstants } from './getEnvironmentConstants';
import { Environment } from '@/constants';

export const getEnvironmentUrlApp = (environment: Environment | '' = '') => {
  const config = getEnvironmentConstants(environment);
  return config.webapp.appUrl;
};
